import { performance } from 'perf_hooks';
import dynamic from 'next/dynamic';
import { GetServerSidePropsContext } from 'next';

import { makeLogger } from '../src/logging';
import getExperiments from '../src/experiments/getExperiments';
import { stcCvtMarketingDynamic } from '../src/experiments/experiments';
import { hasMapping } from '../src/components/Marketing/campaignMapping';

const logger = makeLogger('pages/index');

const getCampaignId = (matches: string | string[]) => {
  if (!matches) {
    return undefined;
  }

  return typeof matches === 'string' ? matches : matches[0];
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const getExperimentsStart = performance.now();
  const { query } = context;

  const isDynamicEligible = hasMapping(getCampaignId(query.utm_content));
  const { experiments, browserCookieId } = await getExperiments(context, 'marketing', {
    [stcCvtMarketingDynamic]: isDynamicEligible
  });

  const getExperimentsTaken = performance.now() - getExperimentsStart;

  logger.info(
    {
      millis: getExperimentsTaken
    },
    'Experiments loaded for Marketing Page'
  );

  return {
    props: {
      experiments,
      browserCookieId
    }
  };
}

const Marketing = dynamic(() => import('../src/components/Marketing/Marketing'));

const HomePage = () => <Marketing />;

export default HomePage;
